import React from "react";
import { useSortable } from "@dnd-kit/sortable";
import { Button } from "../Button";
import { Icon } from "../Icons/LucideIcons";

export const RowDragHandleCell = ({ rowId }: { rowId: string }) => {
  const { attributes, listeners } = useSortable({
    id: rowId,
  });
  return (
    <Button styleVariant="ghost" {...attributes} {...listeners}>
      <Icon iconName="grip-vertical" color="grey300" size={20} />
    </Button>
  );
};
